import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this._onScroll = this.scroll.bind(this)
    window.addEventListener("scroll", this._onScroll, { passive: true })
  }

  disconnect() {
    window.removeEventListener("scroll", this._onScroll)
  }

  scroll() {
    const img = this.element.querySelector("img")
    if (img) img.style.transform = `translateY(${window.scrollY * 0.2}px)`
  }
}
